export default __webpack_public_path__ + "static/media/no-alert-zone.46fcf6bc.svg";